import { render, staticRenderFns } from "./GridNavItem.vue?vue&type=template&id=58cebb55&scoped=true"
import script from "./GridNavItem.vue?vue&type=script&lang=ts"
export * from "./GridNavItem.vue?vue&type=script&lang=ts"
import style0 from "./GridNavItem.vue?vue&type=style&index=0&id=58cebb55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cebb55",
  null
  
)

export default component.exports